export const isShowingSeawareSearch = (): boolean =>
  process.env.REACT_APP_SHOW_SEAWARE === 'true';
